var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonTypeDocs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 100,
    viewBox: "0 0 77 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3261 56.8418H14.2539V63.1567H46.3261V56.8418Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3261 37.8936H14.2539V44.2084H46.3261V37.8936Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3261 18.9482H14.2539V25.2631H46.3261V18.9482Z",
    fill: "#010101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.053 14.7377H60.5813V4.20992C60.5813 1.57797 59.2458 0 57.0174 0H3.56311C1.33553 0 0 1.57797 0 4.20992V82.1034C0 84.7373 1.33553 86.3163 3.56311 86.3163H16.0357V95.7901C16.0357 98.422 17.3721 100 19.5996 100H73.053C75.2815 100 76.617 98.422 76.617 95.7901V18.9476C76.617 16.3147 75.2815 14.7377 73.053 14.7377ZM5.34551 77.8944V8.42083C5.34551 7.10486 6.01328 6.31487 7.12706 6.31487H53.4534C54.5672 6.31487 55.235 7.10486 55.235 8.42083V77.8944C55.235 79.2094 54.5672 79.9984 53.4534 79.9984H7.12706C6.01328 79.9984 5.34551 79.2094 5.34551 77.8944ZM71.2706 91.5772C71.2706 92.8932 70.6029 93.6811 69.4899 93.6811H24.0539C22.9402 93.6811 22.2724 92.8941 22.2724 91.5772V86.3133H57.0174C59.2458 86.3133 60.5813 84.7353 60.5813 82.1024V22.1056H69.4899C70.6029 22.1056 71.2706 22.8935 71.2706 24.2095V91.5772Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonTypeDocs);
export default __webpack_public_path__ + "static/media/lesson_type_docs.b6882f41580c75fef511135f59caede1.svg";
export { ForwardRef as ReactComponent };